import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import Algo from "@/views/AlgoPrescription.vue";
import Fiches from "@/views/FichesInformations.vue";
import Switch from "@/views/SwitchContraception.vue";
import Oestroprogestative from "@/views/Oestroprogestative.vue";
import Microprogestative from "@/views/Microprogestative.vue";
import Diuaucuivre from "@/views/Diuaucuivre.vue";
import Siuaulevonorgestrels from "@/views/Siuaulevonorgestrels.vue";
import Anneau from "@/views/Anneau.vue";
import Patch from "@/views/Patch.vue";
import Leprogestatifinjectable from "@/views/Leprogestatifinjectable.vue";
import Etonogestrel from "@/views/Etonogestrel.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/algroprescriptions",
    name: "Algo",
    component: Algo,
  },
  {
    path: "/fichesinformations",
    name: "Fiches",
    component: Fiches,
  },
  {
    path: "/switchcontraceptions",
    name: "Switch",
    component: Switch,
  },
  {
    path: "/fichesinformations/oestroprogestative",
    name: "Oestroprogestative",
    component: Oestroprogestative,
  },
  {
    path: "/fichesinformations/microprogestative",
    name: "Microprogestative",
    component: Microprogestative,
  },
  {
    path: "/fichesinformations/diuaucuivre",
    name: "Diuaucuivre",
    component: Diuaucuivre,
  },
  {
    path: "/fichesinformations/siuaulevonorgestrels",
    name: "Siuaulevonorgestrels",
    component: Siuaulevonorgestrels,
  },
  {
    path: "/fichesinformations/anneau",
    name: "Anneau",
    component: Anneau,
  },
  {
    path: "/fichesinformations/patch",
    name: "Patch",
    component: Patch,
  },
  {
    path: "/fichesinformations/leprogestatifinjectable",
    name: "Leprogestatifinjectable",
    component: Leprogestatifinjectable,
  },
  {
    path: "/fichesinformations/etonogestrel",
    name: "Etonogestrel",
    component: Etonogestrel,
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // },
  // {
  //   path: "/about/new",
  //   name: "New",
  //   component: New
  // }
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

export default router;
